import { useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { AtrtributeTshirtSizeDTO, EventsApiService } from 'features/events';
import { queryClient } from 'providers';

import { eventsQueryKeys } from './query-keys';

const { updateAttributeTshirtSize } = EventsApiService();

export const useUpdateAttributeTshirtSize = () => {
    const { message } = App.useApp();

    return useMutation(
        (payload: AtrtributeTshirtSizeDTO) => {
            return updateAttributeTshirtSize(payload);
        },
        {
            onError: (error) => {
                const uiMessage = handleError(error);

                message.error(uiMessage);
            },
            onSuccess: () => {
                queryClient.invalidateQueries({
                    queryKey: eventsQueryKeys.all,
                });
                message.success('t-shirt size updated successfully');
            },
        },
    );
};
